export default __webpack_public_path__ + "static/media/affiche.f6c9b3d9.jpg";